import React from 'react';
import DashboardNavBar from './DashboardNavBar';
import styles from './MessagesComp.module.css'

const MessagesComp = ({ sethamburgerMenu }) => {
    return (
        <div className={styles.spanning}>
            <DashboardNavBar sethamburgerMenu={sethamburgerMenu} />
            <h1>Messages were here</h1>
            <h1>Messages were here</h1>
            <h1>Messages were here</h1>
            <h1>Messages were here</h1>
            <h1>Messages were here</h1>
            <h1>Messages were here</h1>
        </div>
    )
}

export default MessagesComp
